import { size } from 'lodash';
import { isCNPJ } from 'validation-br';
import { z } from 'zod';
import { onlyNumbers } from '@/utils/onlyNumbers';

export const preRegistrationSchema = z
  .object({
    cnpj: z
      .string({ required_error: 'Por favor, insira seu CNPJ.' })
      .min(1, 'Por favor, insira seu CNPJ.')
      .refine((cnpj) => {
        const cleanedCnpj = onlyNumbers(cnpj);

        if (cleanedCnpj && size(cleanedCnpj) === 14) {
          return isCNPJ(cleanedCnpj);
        }
        return false;
      }, 'Este CNPJ é inválido. Por favor, tente novamente.'),
    email: z
      .string({ required_error: 'Por favor, digite seu e-mail.' })
      .min(1, 'Por favor, digite seu e-mail.')
      .email('Este e-mail é inválido. Por favor, tente novamente.'),
    motivation: z.object(
      {
        value: z.string(),
        label: z.string(),
        withDescriptionField: z.boolean()
      },
      {
        required_error: 'Por favor, selecione uma Origem.'
      }
    ),
    motivationDescription: z.string().optional()
  })
  .superRefine((data, ctx) => {
    if (data.motivation?.withDescriptionField) {
      if (!data.motivationDescription || size(data.motivationDescription.trim()) === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Por favor, descreva como conheceu a AXA.',
          path: ['motivationDescription']
        });
      }
    }
  });

export type PreRegistrationFormData = z.infer<typeof preRegistrationSchema>;
